import { useEffect } from 'react';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { CustomEventService, IEvents } from '@mfe-helpers/customEvent';
import { composeMPUPageViewPayload, composePageViewPayload } from '@mfe-helpers/tracking';
import { useAppContext } from '@mfe-presentation/contexts';

const useSendPageView = () => {
    const {
        currentStep: { index, name },
        portal,
        formValues,
    } = useAppContext();

    useEffect(() => {
        const eventPayload =
            name === 'update'
                ? composeMPUPageViewPayload({
                      pageTitle: 'update_estimation',
                      category: 'estimate',
                      portal: portal as Portal,
                      formValues,
                  })
                : composePageViewPayload({
                      stepIndex: index,
                      pageTitle: `estimate_step${index + 1}_${name}`,
                      portal: portal as Portal,
                      formValues,
                  });

        CustomEventService.fire(IEvents.SEND_PAGE_VIEW, eventPayload);
    }, [index]);
};

export default useSendPageView;
